// @react/hooks/useFiscalizationReport.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { fiscalizationReportStore } from '@core/stores';

/**
 * React hook for  operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFiscalizationReport } from '@react/hooks';
 *
 * const List = observer(() => {
 *   const store = useFiscalizationReport();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFiscalizationReport() {
  return fiscalizationReportStore;
}
